import { useCallback, useEffect, useState } from 'react';

import professionSalaryDynamicsButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/profession_salary_dynamics_button_click';
import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Title, useBreakpoint, Card } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import { StatisticDetailItem } from 'src/models/pages/profession';

import Chart from 'src/pages/Profession/components/SectionStatistics/DetailChart/Chart';
import DetailChartBarInfo from 'src/pages/Profession/components/SectionStatistics/DetailChart/DetailChartBarInfo';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.profession.sections.statistic.detail.title',
};

const DetailChartRow: TranslatedComponent = ({ trls }) => {
    const { initValue, values } = useSelectorNonNullable((state) => state.pageProfession.statistic.detail);

    const [selectedItem, setSelectedItem] = useState<StatisticDetailItem>(initValue);
    const handleSelect = useCallback((value: StatisticDetailItem) => {
        professionSalaryDynamicsButtonClick({ buttonName: 'salary_bar' });
        setSelectedItem(value);
    }, []);

    const { isMobile } = useBreakpoint();

    useEffect(() => {
        setSelectedItem(initValue);
    }, [initValue]);

    return (
        <Card
            padding={isMobile ? 16 : 24}
            borderRadius={isMobile ? 16 : 32}
            showBorder
            stretched
            data-qa="section-statistics-detail-chart"
        >
            <header className={styles.header}>
                <Title size={isMobile ? 'small' : 'medium'} Element="h2">
                    {trls[TrlKeys.title]}
                </Title>
                <DetailChartBarInfo item={selectedItem} isMobile={isMobile} />
            </header>
            <Chart data={values} selectedItem={selectedItem} onSelect={handleSelect} />
        </Card>
    );
};

export default translation(DetailChartRow);
